(function() {
  var store;
  store = window.Store || (window.Store = {});
  store.Models = store.Models || (store.Models = {});
  store.Models.AppModel = Backbone.Model.extend({
    initialize: function(options) {
      this.bind('collection-image-fade', this.imageFade);
    },
    imageFade: function(e) {
      console.log('collection-image-fade');
    }
  });
}).call(this);
